// extracted by mini-css-extract-plugin
module.exports = {"switch-wrapper":"stage_settings__switch-wrapper___WlPDU","switchWrapper":"stage_settings__switch-wrapper___WlPDU"};